module.exports = __webpack_public_path__ + "media/img/decorations/decoration-sidebar-d3957f7ff259c9a53db29b26b71d9f36.svg";